import React from "react";
import "./zeitersparnis.scss";
import ZeitersparnisImage from "../../../../assets/images/zeitersparnis.png";
import ZeitersparnisImage1 from "../../../../assets/images/tablet-image.png";
import { NavLink } from "react-router-dom";
export default function Zeitersparnis() {
  return (
    <div>
      <div className="zeitersparnis-section-all-content-alignment">
        <div className="grid">
          <div className="grid-items">
            <div className="box-width">
              <h5
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Zeitersparnis für Ihr Backoffice
              </h5>
              <p
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Die Zentrale des DEUTSCHEN IMMOBILIEN DIENSTES ist 7 Tage die
                Woche rund um die Uhr besetzt. Sobald Sie persönlich nicht
                verfügbar sind, werden alle eingehenden Anrufe auf die Zentrale
                umgeleitet. Die Anrufe werden also laufend bearbeitet und die
                Informationen umgehend an Sie weitergeleitet.
              </p>
              <div className="outline-primary-button">
                <NavLink to="/kontakt">
                  <button>Kontakt aufnehmen</button>
                </NavLink>
              </div>
            </div>
          </div>
          <div className="grid-items">
            <div className="image-style">
              <img
                className="animate__backInUp animate__animated wow"
                data-wow-offset="100"
                src={ZeitersparnisImage}
                alt="ZeitersparnisImage"
              />
              <img
                className="animate__backInUp animate__animated wow"
                data-wow-offset="100"
                src={ZeitersparnisImage1}
                alt="ZeitersparnisImage1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
